/**
 * Welcome Discount Modal
 * Detects welcome_discount URL parameter and shows success modal
 */

class WelcomeDiscountModal {
  constructor() {
    this.modal = document.getElementById('WelcomeDiscountModal');
    this.paramName = 'welcome_discount';
    this.sessionKey = 'welcomeDiscountShown';

    if (!this.modal) return;

    this.init();
  }

  init() {
    // Check if we should show the modal
    if (this.shouldShowModal()) {
      this.showModal();
      this.cleanUrl();
      this.markAsShown();
    }

    // Bind close button
    this.bindCloseEvents();
  }

  shouldShowModal() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasParam = urlParams.get(this.paramName) === '1';
    const alreadyShown = sessionStorage.getItem(this.sessionKey) === 'true';

    return hasParam && !alreadyShown;
  }

  showModal() {
    // Small delay to ensure page is rendered
    setTimeout(() => {
      if (this.modal && typeof this.modal.show === 'function') {
        this.modal.show();
      } else {
        // Fallback if modal-dialog custom element not ready
        this.modal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');

        // Focus the dialog
        const dialog = this.modal.querySelector('[role="dialog"]');
        if (dialog) {
          dialog.focus();
        }
      }
    }, 100);
  }

  cleanUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete(this.paramName);

    // Update URL without reload
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }

  markAsShown() {
    sessionStorage.setItem(this.sessionKey, 'true');
  }

  bindCloseEvents() {
    // Close button
    const closeBtn = this.modal.querySelector('[data-close-modal]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hideModal());
    }

    // Also bind the standard close button
    const standardClose = this.modal.querySelector('[id^="ModalClose-"]');
    if (standardClose) {
      standardClose.addEventListener('click', () => this.hideModal());
    }

    // Click outside to close
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.hideModal();
      }
    });

    // ESC key to close
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.modal.hasAttribute('open')) {
        this.hideModal();
      }
    });
  }

  hideModal() {
    if (this.modal && typeof this.modal.hide === 'function') {
      this.modal.hide();
    } else {
      // Fallback
      this.modal.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new WelcomeDiscountModal());
} else {
  new WelcomeDiscountModal();
}
